import React, {
    FC, useCallback, useMemo, useState,
} from 'react';
import { ICON_TYPE_CLOSE_SLIM } from 'ui-library/components/Icon';
import UploadDocuments from 'components/UploadDocuments/UploadDocuments';
import {
    Loader, Modal, notification, Icon,
} from '../../../../../ui-library';
import ServiceManager from '../../../../../services/ServiceManager';
import { getBase64FromFile } from '../../../../../utils/file';
import { UploadPersonalDocumentsModalProps } from './UploadPersonalDocumentsModalProps.types';
import './UploadPersonalDocumentsModal.css';

const UploadPersonalDocumentsModal: FC<UploadPersonalDocumentsModalProps> = (props) => {
    const {
        onClose,
        onUploadSuccess,
        clientId,
        visible,
        width,
        fileTypesAllowed,
        numberOfFilesAllowed,
        resouces,
    } = props;

    const [files, setFiles] = useState<File[]>([]);
    const [error, setError] = useState<string>('');
    const [uploadInProgress, setUploadInProgress] = useState(false);

    const closeIcon = useMemo(() => (<Icon type={ICON_TYPE_CLOSE_SLIM} size={20} />), []);

    const onUpload = useCallback(async () => {
        try {
            setUploadInProgress(true);
            const payload = {
                ownerId: clientId,
                documents: await Promise.all(files.map(async (file) => ({
                    filename: file.name,
                    file: (await getBase64FromFile(file)).split(',')[1],
                }))),
            };

            await ServiceManager.customDocumentsService('uploadIdDocument', [payload]);

            onClose();
            onUploadSuccess();
        } catch (err) {
            const errorMessage = (err instanceof Error && err.message) ? err.message : 'An unknown error occurred';

            notification.open({ content: errorMessage, type: 'error' });
        } finally {
            setUploadInProgress(false);
        }
    }, [onUploadSuccess, clientId, files]);

    const onFileUpload = useCallback((uploadedFiles: File[]) => {
        setFiles(uploadedFiles);
    }, []);

    return (
        <Modal
            className="upload-personal-documents-modal"
            keyboard={false}
            maskClosable={false}
            closeIcon={closeIcon}
            closable
            borderRadius
            visible={visible}
            width={width}
            okText={uploadInProgress ? <Loader /> : resouces.okText}
            cancelText={resouces.cancelText}
            okButtonProps={{ disabled: !files.length || uploadInProgress || files.length > numberOfFilesAllowed }}
            onOk={onUpload}
            onCancel={onClose}
            title={resouces.title}
        >
            <div className="content-container">
                <div className="mb-16">
                    {resouces.sensitiveDataInfo}
                </div>
                <div className="UploadWidget__allowed-document-types mb-8">
                    {resouces.allowedFileTypesInfo}
                </div>
                <div>
                    <UploadDocuments
                        className="upload-personal-documents"
                        onSuccess={onFileUpload}
                        onError={setError}
                        fileTypesAllowed={fileTypesAllowed}
                        numberOfFiles={numberOfFilesAllowed}
                    />
                </div>
                {error && (
                    <div className="form-group form-group_invalid mt-12">
                        <span className="form-control-message">
                            {error}
                        </span>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default UploadPersonalDocumentsModal;
